import { render, staticRenderFns } from "./list_item_description.vue?vue&type=template&id=a8efef1e"
import script from "./list_item_description.vue?vue&type=script&lang=js"
export * from "./list_item_description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports